import { Form } from "../Abstracts/Form";
import { EntityModalForm } from "../CRUDs/abstracts/mixins/EntityModalForm";
import { FormActions } from "../CRUDs/abstracts/mixins/FormActions";
import { SaveButton } from '../components/SaveButton';

export const RefundForm = (() => {

    function validate() {
        const form = document.querySelector('#refund-invoice');
        const max = parseFloat(form.querySelector('#max').value);

        const amountInput = form.querySelector('[name=amount]');
        const amountValue = amountInput.value;


        // try {
        //     if (max < parseFloat(amountValue)) {

        //     }
        // } catch {

        // }

    }

    return class RefundForm extends Form {

        constructor(invoice) {

            super('refund-invoice-modal', `${invoice.urlRoot}/${invoice.id}/refund`, 'POST');

            this.formInfo = document.querySelector(`#payment-invoice-modal`);

            this.submitBtn = this.form.querySelector(`#refund`);
            this.listners();
            this.saveButton = new SaveButton('#refund-invoice');
            Object.assign(RefundForm.prototype, FormActions);
        }

        async submit() {
            this.saveButton.startLoading('Sending');
            const data = this.collectDataInForm('refund-invoice');
            const response = await fetch(this.actionUrl, {
                method: this.method,
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
            const result = await response.json();
            this.saveButton.stopLoading();
            if (response.ok) 
                this.successCallback(result);
            else{
                if(result.reason) {
                    $('#refund-invoice #error-message').text(result.reason);
                    this.saveButton.showError();
                }else{
                    this.errorCallback(result)
                }
            }
        }

        async successCallback(result) {
            const formHTML = result.modal;
            EntityModalForm.pasteForm(formHTML);
            $('.modal-backdrop').first().remove();
            $('#success_refund-modal').modal('show');
        }

        async errorCallback(result) {
            const formHTML = result.modal;
            EntityModalForm.pasteForm(formHTML);
            $('.modal-backdrop').first().remove();
            $('#failed_refund-modal').modal('show');
        }

        listners() {
            super.listners();
        }
    }
})();
